
import React from "react";
//import Button from "../common/Button";
import styles from "../css/FeatureFocused.module.css";

const FeatureFocused = ({ data }: any) => {
  return (
    <section className={styles.featureFocused}>
      <h2 className={styles.headline}>{data.headline}</h2>
      <p className={styles.introText}>{data.introText}</p>
      <div className={styles.features}>
        {data.features.map((feature: any, index: number) => (
          <div key={index} className={styles.feature}>
            <i className={`${styles.icon} ${feature.icon}`}></i>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
            <ul className={styles.benefits}>
              {feature.benefits.map((benefit: any, bIndex: number) => (
                <li key={bIndex}>{benefit}</li>
              ))}
            </ul>
            {feature.image && (
              <img 
                src={feature.image.src} 
                alt={feature.image.alt} 
                className={styles.featureImage}
              />
            )}
          </div>
        ))}
      </div>
      {data.comparisonTable && (
        <div className={styles.comparisonTable}>
          <h3>{data.comparisonTable.title}</h3>
          <table>
            <thead>
              <tr>
                {data.comparisonTable.headers.map((header: any, index: number) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.comparisonTable.rows.map((row: any, rowIndex: number) => (
                <tr key={rowIndex}>
                  {row.map((cell: any, cellIndex: number) => (
                    <td key={cellIndex}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className={styles.ctaContainer}>
        {/*<Button {...data.primaryCTA} />*/}
      </div>
    </section>
  );
};

export default FeatureFocused;
